/* VERUMBRA — interacciones. Un solo archivo, guard de ejecución única, inits idempotentes. */
(function () {
  if (window.__vrInit) return;
  window.__vrInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var esMovil = function () { return window.matchMedia('(max-width: 989px)').matches; };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ---------- Reveals ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('vr-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function observar(root) {
    root.querySelectorAll('.vr-reveal, .vr-words, [data-vr-reveal]').forEach(function (el) {
      if (el.dataset.vrObs) return; el.dataset.vrObs = '1';
      if (!io || reduce.matches) { el.classList.add('vr-visible'); return; }
      io.observe(el);
    });
  }

  /* Titulares por palabras: respeta <em> como una sola pieza */
  function partirPalabras(root) {
    root.querySelectorAll('[data-vr-words]').forEach(function (el) {
      if (el.dataset.vrSplit) return; el.dataset.vrSplit = '1';
      var i = 0;
      var nodos = Array.prototype.slice.call(el.childNodes);
      el.innerHTML = '';
      nodos.forEach(function (n) {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { el.appendChild(document.createTextNode(' ')); return; }
            var s = document.createElement('span'); s.className = 'vr-word';
            s.innerHTML = '<span style="--i:' + (i++) + '">' + w + '</span>';
            el.appendChild(s);
          });
        } else if (n.nodeType === 1 && n.tagName === 'BR') {
          el.appendChild(n);
        } else if (n.nodeType === 1) {
          var w = document.createElement('span'); w.className = 'vr-word' + (n.classList.contains('vr-cursiva') ? ' vr-word--bloque' : '');
          var inner = document.createElement('span'); inner.style.setProperty('--i', i++);
          inner.appendChild(n); w.appendChild(inner); el.appendChild(w);
          if (n.classList.contains('vr-cursiva')) { w.style.display = 'block'; n.style.display = 'inline'; }
        }
      });
      el.classList.add('vr-words');
    });
  }

  /* ---------- Cabecera: transparente sobre el héroe y fija al bajar ---------- */
  function initCabecera() {
    var cab = document.querySelector('[data-vr-cab]');
    if (!cab || cab.dataset.vrInit) return; cab.dataset.vrInit = '1';
    var sobre = cab.hasAttribute('data-sobre') && document.querySelector('.vr-hero');
    if (sobre) cab.classList.add('vr-cab--sobre');
    var ultimo = 0, alto = cab.offsetHeight;
    function onScroll() {
      var y = window.scrollY;
      var umbral = sobre ? window.innerHeight * 0.6 : alto + 40;
      if (y > umbral && y < ultimo) { cab.classList.add('vr-cab--fija'); }
      else if (y > umbral && y > ultimo + 4) { cab.classList.remove('vr-cab--fija'); }
      else if (y <= (sobre ? 10 : alto)) { cab.classList.remove('vr-cab--fija'); }
      if (!sobre) document.body.style.paddingTop = cab.classList.contains('vr-cab--fija') ? alto + 'px' : '';
      ultimo = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var cajon = document.querySelector('[data-vr-cajon]');
    var abrir = cab.querySelector('[data-vr-menu]');
    if (cajon && abrir) {
      abrir.addEventListener('click', function () { cajon.classList.add('is-open'); cajon.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; });
      cajon.querySelector('[data-vr-cerrar]').addEventListener('click', cerrarCajon);
      cajon.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', cerrarCajon); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarCajon(); });
    }
    function cerrarCajon() { cajon.classList.remove('is-open'); cajon.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  }

  /* ---------- Marquesina: duplica hasta cubrir 2x el ancho ---------- */
  function initMarquesinas(root) {
    root.querySelectorAll('[data-vr-insc]').forEach(function (m) {
      if (m.dataset.vrInit) return; m.dataset.vrInit = '1';
      var pista = m.querySelector('.vr-insc__pista'); var g = pista.querySelector('.vr-insc__grupo');
      if (!g || !g.children.length) return;
      var original = g.innerHTML; var vueltas = 0;
      while (g.offsetWidth < window.innerWidth * 1.1 && vueltas < 12) { g.insertAdjacentHTML('beforeend', original); vueltas++; }
      var copia = g.cloneNode(true); copia.setAttribute('aria-hidden', 'true'); pista.appendChild(copia);
    });
  }

  /* ---------- Bucle de scroll compartido ---------- */
  var tareas = [];
  var pedido = false;
  function tick() { pedido = false; tareas.forEach(function (t) { t(); }); }
  function pedir() { if (!pedido) { pedido = true; requestAnimationFrame(tick); } }
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir);

  /* Capítulos horizontales */
  function initCapitulos(root) {
    root.querySelectorAll('[data-vr-caps]').forEach(function (s) {
      if (s.dataset.vrInit) return; s.dataset.vrInit = '1';
      var pin = s.querySelector('.vr-caps__pin'); var pista = s.querySelector('.vr-caps__pista'); var barra = s.querySelector('.vr-caps__progreso');
      var n = s.querySelectorAll('.vr-cap').length;
      function activo() { return !reduce.matches && !esMovil() && n > 1; }
      function aplicar() {
        s.classList.toggle('vr-caps--horizontal', activo());
        if (!activo()) { pista.style.transform = ''; return; }
        var r = pin.getBoundingClientRect();
        var total = pin.offsetHeight - window.innerHeight;
        var p = clamp(-r.top / Math.max(total, 1), 0, 1);
        pista.style.transform = 'translate3d(' + (-p * (n - 1) * 100) + 'vw,0,0)';
        if (barra) barra.style.setProperty('--p', p.toFixed(4));
      }
      tareas.push(aplicar); aplicar();
    });
  }

  /* Zoom macro ligado al scroll */
  function initMacro(root) {
    root.querySelectorAll('[data-vr-macro]').forEach(function (s) {
      if (s.dataset.vrInit) return; s.dataset.vrInit = '1';
      var img = s.querySelector('.vr-macro__img'); var max = parseFloat(s.dataset.max || '2.6');
      function aplicar() {
        if (reduce.matches) { img.style.transform = ''; s.classList.add('is-cerca'); return; }
        var r = s.getBoundingClientRect();
        var total = s.offsetHeight - window.innerHeight;
        var p = clamp(-r.top / Math.max(total, 1), 0, 1);
        var e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
        img.style.transform = 'scale(' + (1 + (max - 1) * e).toFixed(4) + ')';
        s.classList.toggle('is-cerca', p > .55);
      }
      tareas.push(aplicar); aplicar();
    });
  }

  /* Paralaje de ventana (lookbook) */
  function initParalaje(root) {
    root.querySelectorAll('[data-vr-parallax]').forEach(function (el) {
      if (el.dataset.vrInit) return; el.dataset.vrInit = '1';
      var vel = parseFloat(el.dataset.vrParallax || '0.22'); var limFijo = parseFloat(el.dataset.vrLim || '0');
      var padre = el.parentElement;
      function aplicar() {
        if (reduce.matches) { el.style.transform = ''; return; }
        var r = padre.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        var lim = limFijo || (el.offsetHeight - padre.offsetHeight) / 2;
        var y = clamp(-centro * vel, -lim, lim);
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      }
      tareas.push(aplicar); aplicar();
    });
  }

  /* Flechas del lookbook sin teletransporte */
  function initPistas(root) {
    root.querySelectorAll('[data-vr-pista]').forEach(function (s) {
      if (s.dataset.vrInit) return; s.dataset.vrInit = '1';
      var pista = s.querySelector('.vr-look__pista'); var items = pista.children; var cont = s.querySelector('[data-vr-contador]');
      var romanos = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII','XIII','XIV','XV','XVI','XVII','XVIII','XIX','XX'];
      function paso() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : pista.clientWidth; }
      function indice() { return Math.round(pista.scrollLeft / Math.max(paso(), 1)); }
      function pintar() { if (cont) cont.textContent = (romanos[indice()] || indice() + 1) + ' / ' + (romanos[items.length - 1] || items.length); }
      function ir(dir) {
        var p = paso(); var max = pista.scrollWidth - pista.clientWidth;
        var destino = clamp((indice() + dir) * p, 0, max);
        var desde = pista.scrollLeft; var t0 = null; var dur = reduce.matches ? 1 : 750;
        pista.classList.add('is-animando');
        function f(t) {
          if (!t0) t0 = t; var k = clamp((t - t0) / dur, 0, 1);
          var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
          pista.scrollLeft = desde + (destino - desde) * e;
          if (k < 1) requestAnimationFrame(f); else { pista.classList.remove('is-animando'); pintar(); }
        }
        requestAnimationFrame(f);
      }
      s.querySelectorAll('[data-vr-dir]').forEach(function (b) { b.addEventListener('click', function () { ir(parseInt(b.dataset.vrDir, 10)); }); });
      pista.addEventListener('scroll', function () { pintar(); pedir(); }, { passive: true });
      pintar();
    });
  }

  /* Puntos de detalle */
  function initDetalles(root) {
    root.querySelectorAll('[data-vr-det]').forEach(function (s) {
      if (s.dataset.vrInit) return; s.dataset.vrInit = '1';
      var puntos = s.querySelectorAll('[data-punto]'); var items = s.querySelectorAll('[data-item]');
      function activar(k) {
        puntos.forEach(function (p) { p.classList.toggle('is-activo', p.dataset.punto === k); });
        items.forEach(function (i) { i.classList.toggle('is-activo', i.dataset.item === k); });
      }
      puntos.forEach(function (p) { ['mouseenter', 'focus', 'click'].forEach(function (ev) { p.addEventListener(ev, function () { activar(p.dataset.punto); }); }); });
      items.forEach(function (i) { i.addEventListener('mouseenter', function () { activar(i.dataset.item); }); });
      if (items[0]) activar(items[0].dataset.item);
    });
  }

  /* Manifiesto que se ilumina palabra a palabra */
  function initManifiesto(root) {
    root.querySelectorAll('[data-vr-mani]').forEach(function (s) {
      if (s.dataset.vrInit) return; s.dataset.vrInit = '1';
      var txt = s.querySelector('.vr-mani__texto');
      var html = txt.innerHTML.replace(/<em>(.*?)<\/em>/g, '\u0001$1\u0002');
      var out = ''; var dentro = false;
      html.split(/(\s+|\u0001|\u0002)/).forEach(function (t) {
        if (t === '\u0001') { dentro = true; return; }
        if (t === '\u0002') { dentro = false; return; }
        if (!t) return;
        if (/^\s+$/.test(t)) { out += ' '; return; }
        out += dentro ? '<em class="vr-pal">' + t + '</em>' : '<span class="vr-pal">' + t + '</span>';
      });
      txt.innerHTML = out;
      var pals = txt.querySelectorAll('.vr-pal');
      function aplicar() {
        if (reduce.matches) { pals.forEach(function (p) { p.classList.add('is-luz'); }); return; }
        var r = txt.getBoundingClientRect(); var vh = window.innerHeight;
        var p = clamp((vh * .82 - r.top) / (r.height + vh * .35), 0, 1);
        var n = Math.round(p * pals.length);
        pals.forEach(function (w, k) { w.classList.toggle('is-luz', k < n); });
      }
      tareas.push(aplicar); aplicar();
    });
  }

  /* ---------- Producto: tallas, galería, guía, barra fija ---------- */
  function formatear(c) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.vrFormatoDinero) return Shopify.formatMoney(c, window.vrFormatoDinero);
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' €'; }
  }
  function initProducto(root) {
    root.querySelectorAll('[data-vr-producto]').forEach(function (s) {
      if (s.dataset.vrInit) return; s.dataset.vrInit = '1';
      var datos = s.querySelector('[data-variantes]');
      var form = s.querySelector('form[action*="/cart/add"]');
      var inputId = form && form.querySelector('[name=id]');
      var boton = form && form.querySelector('[type=submit]');
      var textoBoton = boton && boton.querySelector('span');
      var precio = s.querySelector('[data-precio]');
      var tachado = s.querySelector('[data-tachado]');
      var pegPrecio = document.querySelector('[data-peg-precio]');
      if (datos && form) {
        var variantes = JSON.parse(datos.textContent);
        var sets = s.querySelectorAll('[data-opcion]');
        function seleccion() { return Array.prototype.map.call(sets, function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; }); }
        function actualizar() {
          var sel = seleccion();
          var v = variantes.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
          sets.forEach(function (f, k) {
            f.querySelectorAll('input').forEach(function (inp) {
              var prueba = sel.slice(); prueba[k] = inp.value;
              var hay = variantes.some(function (x) { return x.available && x.options.every(function (o, j) { return o === prueba[j]; }); });
              inp.closest('.vr-talla').classList.toggle('vr-talla--agotada', !hay);
            });
          });
          if (!v) { boton.disabled = true; textoBoton.textContent = boton.dataset.noDisponible; return; }
          inputId.value = v.id;
          boton.disabled = !v.available;
          textoBoton.textContent = v.available ? boton.dataset.anadir : boton.dataset.agotado;
          if (precio) precio.textContent = formatear(v.price);
          if (pegPrecio) pegPrecio.textContent = formatear(v.price);
          if (tachado) { tachado.textContent = v.compare_at_price > v.price ? formatear(v.compare_at_price) : ''; }
          if (window.history && window.history.replaceState && s.dataset.url) {
            window.history.replaceState({}, '', s.dataset.url + '?variant=' + v.id);
          }
        }
        sets.forEach(function (f) { f.addEventListener('change', actualizar); });
        actualizar();
      }
      /* visor de fotos */
      var visor = document.querySelector('[data-vr-visor]');
      if (visor) {
        var vImg = visor.querySelector('img');
        s.querySelectorAll('[data-zoom]').forEach(function (im) {
          im.addEventListener('click', function () { vImg.src = im.dataset.zoom; visor.classList.add('is-open'); });
        });
        visor.addEventListener('click', function () { visor.classList.remove('is-open'); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') visor.classList.remove('is-open'); });
      }
      /* barra fija en móvil */
      var peg = document.querySelector('[data-vr-pegajosa]');
      if (peg && boton) {
        tareas.push(function () { peg.classList.toggle('is-visible', boton.getBoundingClientRect().bottom < 0); });
        peg.querySelector('button').addEventListener('click', function () { boton.click(); });
      }
    });
  }

  /* Guía de tallas (cajón) */
  function initGuia() {
    var guia = document.querySelector('[data-vr-guia]');
    if (!guia || guia.dataset.vrInit) return; guia.dataset.vrInit = '1';
    var ultimo = null;
    function abrir(e) { ultimo = e && e.currentTarget; guia.classList.add('is-open'); guia.setAttribute('aria-hidden', 'false'); guia.querySelector('[data-vr-guia-cerrar]').focus(); }
    function cerrar() { guia.classList.remove('is-open'); guia.setAttribute('aria-hidden', 'true'); if (ultimo) ultimo.focus(); }
    document.querySelectorAll('[data-abrir-tallas]').forEach(function (b) { b.addEventListener('click', abrir); });
    guia.querySelectorAll('[data-vr-guia-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && guia.classList.contains('is-open')) cerrar(); });
  }

  function init(root) {
    root = root || document;
    partirPalabras(root);
    observar(root);
    initCabecera();
    initMarquesinas(root);
    initCapitulos(root);
    initMacro(root);
    initParalaje(root);
    initPistas(root);
    initDetalles(root);
    initManifiesto(root);
    initProducto(root);
    initGuia();
    pedir();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
